<template>
  <div>
    <article class="slds-card">
      <Spinner v-if="!users.length" />

      <div v-else>
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__figure">
              <span
                class="slds-icon_container slds-icon-standard-user"
                :title="$t('usersManagement.users')"
              >
                <svg
                  class="slds-icon slds-icon-action-user"
                  aria-hidden="true"
                >
                  <use xlink:href="../assets/symbols.svg#user"></use>
                </svg>
                <span class="slds-assistive-text">{{$t('usersManagement.users')}}</span>
              </span>
            </div>
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span
                  class="slds-card__header-link slds-truncate"
                  :title="$t('usersManagement.users')"
                >
                  <span>{{$t('usersManagement.users')}}</span>
                </span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner" >
          <article class="slds-card slds-card_boundary filter-panel" >
            <div class="slds-card__body slds-card__body_inner" >
              <div class="slds-form-element" >
                <SLDSInput
                  :placeholder="$t('action.filter')"
                  has-left-icon
                  type="text"
                  v-model="searchKey"
                >
                  <use
                    xlink:href="../assets/symbols.svg#search"
                    slot="leftIcon"
                  ></use>
                </SLDSInput>
              </div>

              <div class="row">
                <Picklist
                  :label="$t('usersManagement.filters.status.label')"
                  :options="settings.active"
                  include-all-value
                  labels-prefix="usersManagement.filters.active"
                  v-model="filters.active"
                  style="width: 25%"
                />

                <Picklist
                  :label="$t('usersManagement.user.countries')"
                  :options="settings.countries_raw"
                  :sortLabel=true
                  searchable
                  include-all-value
                  labels-prefix="country"
                  multipicklist
                  v-model="filters.countries"
                  style="width: 25%"
                />

                  <Picklist
                  :label="$t('usersManagement.user.brands')"
                  :options="settings.brands"
                  :sortLabel=true
                  searchable
                  include-all-value
                  labels-prefix="brands"
                  multipicklist
                  v-model="filters.brands"
                  style="width: 25%"
                />

                <Picklist
                  :label="$t('usersManagement.user.role')"
                  :options="settings.role"
                  include-all-value
                  labels-prefix="usersManagement.user.roles"
                  v-model="filters.role"
                  style="width: 20%"
                />
              </div>
            </div>

          </article>

          <UsersTable
            class="users-table"
            v-model="filteredUsers"
            @edit="editRow"
            @sortChange="changeSortingOptions"
            :sorting-options="sortingOptions"
          />
        </div>
      </div>
    </article>

    <transition name="fade">
      <Modal
        v-if="showModal"
        :title="$t('usersManagement.editUser')"
        @close="closeModal"
        @neutralButtonClick="cancelUserEdit"
        @positiveButtonClick="saveUser"
        :positive-button-text="$t('action.save')"
        :neutral-button-text="$t('action.cancel')"
        >
        <SLDSInput
          :label="$t('usersManagement.user.name')"
          v-model="selectedUser.name"
          disabled
        />
        <SLDSInput
          :label="$t('usersManagement.user.email')"
          v-model="selectedUser.email"
          disabled
        />

        <Picklist
          labels-prefix="country"
          multipicklist
          ref="countries"
          searchable
          include-all-value
          v-model="selectedUser.countries"
          :sortLabel=true
          :label="$t('usersManagement.user.countries')"
          :options="settings.countries_raw"
          :validation="[{name: 'conditional-required', param: selectedUser.active, message: 'validation.custom.conditionalRequiredUserManagement'}]"
        />

        <Picklist
          labels-prefix="brands"
          multipicklist
          ref="brands"
          searchable
          include-all-value
          v-model="selectedUser.brands"
          :sortLabel=true
          :label="$t('usersManagement.user.brands')"
          :options="settings.brands"
          :validation="[{name: 'conditional-required', param: selectedUser.active, message: 'validation.custom.noBrands'}]"
        />

        <Picklist
          :label="$t('usersManagement.user.role')"
          :tooltip="$t('usersManagement.user.role_tooltip')"
          :options="settings.role"
          tooltip-direction="right"
          labels-prefix="usersManagement.user.roles"
          v-model="selectedUser.role"
        />

        <!-- <IncludedFilter
          :label="$t('usersManagement.user.visibility')"
          v-model="selectedUser.visibility" /> -->

        <Picklist
          :label="$t('usersManagement.user.visibility')"
          multipicklist
          :tooltip="$t('usersManagement.user.visibility_tooltip')"
          tooltip-direction="right"
          :options="['CAMPAIGN_STELLANTIS', 'CAMPAIGN_TECHNICAL']"
          v-model="selectedUser.visibility"
        />
        <SLDSInput
          type="checkbox"
          :label="$t('usersManagement.user.active')"
          v-model="selectedUser.active"
        />
      </Modal>
    </transition>
  </div>
</template>
<script>
import _ from 'lodash'
import IncludedFilter from '../components/campaign-manager/filters/IncludedFilter'
import Modal from '../components/Modal'
import Input from '../components/slds/Input'
import Spinner from '../components/Spinner'
import Picklist from '../components/slds/Picklist'
import UsersTable from '../components/users-management/UsersTable'
import { applyFiltersToList } from '../components/utils/utils'

export default {
  components: {
    IncludedFilter,
    Modal,
    Picklist,
    SLDSInput: Input,
    Spinner,
    UsersTable
  },
  async created () {
    try {
      this.settings = await this.$store.dispatch('settings/getSettings')
      this.users = await this.$store.dispatch('userManagement/getUsers')
      //console.log(this.settings)
      this.doFilter()

      this.$store.watch(
        (state, getters) => getters['userManagement/userList'],
        newValue => {
          this.users = newValue
          this.doFilter()
        },
        {
          deep: true
        }
      )
    } catch (err) {
      throw err
    }
  },
  data () {
    return {
      filteredUsers: [],
      filters: {
        active: '',
        countries: '',
        role: ''
      },
      searchKey: '',
      selectedUser: {},
      settings: {},
      showModal: false,
      sortingOptions: {
        field: 'name',
        direction: 'asc'
      },
      users: []
    }
  },
  methods: {
    cancelUserEdit () {
      //console.log(this.selectedUser)
      this.selectedUser = {}
      this.showModal = false
    },
    changeSortingOptions (event) {
      this.sortingOptions = event.sortingOptions
      this.doFilter()
    },
    closeModal () {
      this.showModal = false
      this.selectedUser = {}
    },
    applyFilters: _.debounce((list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback) => applyFiltersToList(list, searchKey, filtersObject, fieldsToFilter, sortingOptions, callback), 300),
    doFilter () {
      this.applyFilters(this.users, this.searchKey, this.filters, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
    },
    editRow (event) {
      this.selectedUser = JSON.parse(JSON.stringify(this.users.find(u => u.sfmcId === event.id)))
      this.showModal = true
    },
    async saveUser () {
      try {
       if (this.$refs.countries.validate() && this.$refs.brands.validate()) {
          await this.$store.dispatch('userManagement/updateUser', this.selectedUser)
          const userid = this.selectedUser.sfmcId
          this.selectedUser = {}
          this.showModal = false
          this.showToast('success', this.$t('general.success'), 'text')
          if (userid === this.$store.getters["session/userId"]) {
            await this.$store.dispatch('session/login')
          }
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error.toJSON().message)
      }
    }
  },
  watch: {
    async searchKey (searchKey) {
      this.applyFilters(this.users, searchKey, this.filters, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
    },
    filters: {
      handler: function (value) {
        this.applyFilters(this.users, this.searchKey, value, ['name', 'email'], this.sortingOptions, (result) => { this.filteredUsers = result })
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-panel {
  margin-bottom: 10px;
}

.row {
  display: flex;
  flex-direction: row;

  & .slds-form-element {
    flex-grow: 1;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}
</style>
